import { render, staticRenderFns } from "./OvertimesList.vue?vue&type=template&id=72758648&scoped=true&"
import script from "./OvertimesList.vue?vue&type=script&lang=js&"
export * from "./OvertimesList.vue?vue&type=script&lang=js&"
import style0 from "./OvertimesList.vue?vue&type=style&index=0&id=72758648&lang=scss&scoped=true&"
import style1 from "./OvertimesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72758648",
  null
  
)

export default component.exports